/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const CloseAccount = {
  path: '/close-account',
  name: 'close-account',
  redirect: { name: 'close-account-apply' },
  component: () => import('@/views/close-account/index.vue'),
  children: [
    {
      path: 'apply',
      name: 'close-account-apply',
      component: () =>
        import(/* webpackChunkName: "close-account" */ '@/views/close-account/apply.vue'),
    },
    {
      path: 'sms-verify',
      name: 'close-account-sms-verify',
      component: () =>
        import(/* webpackChunkName: "close-account" */ '@/views/close-account/sms-verify.vue'),
    },
    {
      path: 'confirm',
      name: 'close-account-confirm',
      component: () =>
        import(/* webpackChunkName: "close-account" */ '@/views/close-account/confirm.vue'),
    },
    {
      path: 'reason',
      name: 'close-account-reason',
      component: () =>
        import(/* webpackChunkName: "close-account" */ '@/views/close-account/reason.vue'),
    },
  ],
}
export default CloseAccount
